import React from 'react'
import sortBy from 'lodash/sortBy'
import moment from 'moment'
import { RouteHandler, Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import DocumentTitle from 'react-document-title'
import access from 'safe-access'
import { config } from 'config'
import SitePost from '../SitePost'
import SiteSidebar from '../SiteSidebar'
import Header from '../Header'
import Footer from '../Footer'
import './style.css';

class BlogPage extends React.Component {
    render() {
        const {route} = this.props
        const post = route.page.data

        const pageLinks = []
        // Sort pages.
        const sortedPages = sortBy(this.props.route.pages, (page) => access(page, 'data.date')
        ).reverse()
        sortedPages.forEach((page) => {
            if (access(page, 'file.ext') === 'md' && access(page, 'data.layout') === 'post') {
                const title = access(page, 'data.title') || page.path
                const description = access(page, 'data.description')
                const datePublished = access(page, 'data.date')
                const category = access(page, 'data.category')

                pageLinks.push(
                    <div className='blog-post'>
                       <p className='blog-category'>{ category }</p>
                      <Link className='readmore' to={ prefixLink(page.path) }>
                        <h3>{ title }</h3>
                      </Link>
                    </div>

                )
            }
        })


        return (
            <div className="blog view">
              <Header {...this.props}/>
              <div className='content'>
                <div className='main'>
                  <div className='main-inner'>
                    <div className='blog-page'>
                      <div className='text'>
                        <h1>{ post.title }</h1>
                          { pageLinks }
                      </div>
                      <div className="home-button">
                        <a className="go-home" href="/" title="Back to home">Back to Home</a>
                      </div>
                    </div>
                  </div>
                  <Footer {...this.props} />
                </div>
              </div>
            </div>
            );
    }
}

BlogPage.propTypes = {
    post: React.PropTypes.object.isRequired,
    pages: React.PropTypes.array,
}

export default BlogPage



// WEBPACK FOOTER //
// ../components/BlogPage/index.jsx